export const _state = {
    isGetReportRegulationFetch: false,
    isGetReportTaskFetch: false,
    errors: {},
    regulations: [],
    tasks: [],
};

export function reportsReducer(state = _state, action) {

    switch (action.type) {

        case 'API_GET_REPORT_INITIALIZE':
            return {
                ...state,
                errors: {},
                regulations: [],
                tasks: [],
            };

        case 'API_GET_REPORT_REGULATION_CLOSE_FETCH':
            return {
                ...state,
                isGetReportRegulationFetch: false,
            };

        case 'API_GET_REPORT_TASK_CLOSE_FETCH':
            return {
                ...state,
                isGetReportTaskFetch: false,
            };

        case 'API_GET_REPORT_REGULATION':
            return {
                ...state,
                isGetReportRegulationFetch: true,
            };

        case 'API_GET_REPORT_REGULATION_SUCCESS':
            return {
                ...state,
                regulations: action.payload.data,
            };

        case 'API_GET_REPORT_REGULATION_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        case 'API_GET_REPORT_TASK':
            return {
                ...state,
                isGetReportTaskFetch: true,
            };

        case 'API_GET_REPORT_TASK_SUCCESS':
            return {
                ...state,
                tasks: action.payload.data,
            };

        case 'API_GET_REPORT_TASK_FAIL':
            return {
                ...state,
                errors: action.error.response.data,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reports.js